import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import yml from '@config/parameters.yml'
import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

import { DELIVERY_TYPES, PAYMENT_TYPES } from '@/constants'

Vue.use(Vuex)

export const state = {
    screenWidth: 0,
    isModalOpen: false,
    isUsingShopLogic: true,
    selectedParametersIndexMap: {},
    activeImageIndex: 0,
    currentImageIndex: 0,
    pathImg: '',
    mainImg: '',
    slides: {},
    slideLinkOptions: {},
    cropped: {
        image: '/media/downloads/placeholder-image.png',
        imageOrigin: '/media/downloads/placeholder-image.png',
        imageData: '',
    },
    deliveryAddress: {
        loadedAddresses: null,
        address: {
            city: '',
            street: '',
            house: '',
            fullStreet: '',
        },
        message: '',
    },
    deliveryType: yml.parameters['app.default_delivery'],
    deliveryDetails: {
        deliveryPrices: null,
        thresholdForDeliveryPrice: null,
        remainingAmount: 0,
        message: '',
    },
    pickupPoints: null,
    pickupIntervals: [],
    selectPickupPoint: null,
    selectedModifiers: [],
    selectedGroupModifier: [],
    productPriceModifiers: 0,
    productVariantsList: [],
    slidePreview: {
        title: '',
        subtitle: '',
        buttonTitle: '',
        titleColor: 0,
        subtitleColor: 0,
        align: '',
    },
    product: {
        id: '',
        title: '',
        body: '',
        description: '',
        price: '',
        images: [],
        isBuyable: true,
        variants: [{
            parameters: {
                key: '',
                value: '',
            },
        }],
    },
    feedback: {
        name: '',
        email: '',
        phone: '',
        message: '',
    },
    promoCode: {
        name: '',
        message: '',
        discountPrice: null,
        discount: null,
        discountType: null,
    },
    bonusSystem: null,
    orderDetails: {
        name: '',
        phone: '',
        delivery: {
            type: yml.parameters['app.default_delivery'],
            date: '',
            interval: null,
            price: 0,
            address: {
                apartment: '',
                city: '',
                doorCode: '',
                entrance: '',
                floor: '',
                fullStreet: '',
                house: '',
                street: '',
            },
            pickup: {
                openingHours: [],
                address: '',
                name: '',
            },
        },
        allowSpam: true,
        allowPersonalDataProcessing: true,
        // до тех пор пока нет интеграций с онлайн оплатой - должно быть false
        onlinePayment: false,
        paymentType: PAYMENT_TYPES.COURIER_CASH,
        addressComment: '',
        orderComment: '',
        paidByBonuses: null,
        isPaidByBonuses: false,
        promoCode: null,
        discountPrice: null,
        isAddressChosen: false,
    },
    authenticatorData: {
        phone: '',
        error: '',
        code: null,
    },
    customer: {
        buyerId: null,
        firstName: '',
        lastname: '',
        rawName: null,
        phone: '',
        bonuses: null,
        paidByBonusesLocal: null,
        isAuthenticated: false,
        city: '',
    },
    cityExact: false,
    draftProduct: {},
    activePriceIndex: 0,
    amountProduct: null,
    currentVariants: [],
    availableParameters: [],
    lengthParameters: 0,
    cities: [],
    // двумерный массив дней от 0 до 13, в каждом из которых интервалы доставки
    // временным промежутками
    deliveryIntervals: [[{ date: '' }]],
    questions: [],
    filters: {
        price: {
            min: 0,
            max: 0,
        },
        options: [],
        active: {
            price: {
                from: 0,
                to: 0,
            },
            options: [],
        },
    },
    shopContacts: {
        address: '',
        email: '',
        phone: '',
    },
    products: [],
    // initProducts создан, т.к. в проекте уже существуют зависимости products
    // и нужен был список всех продуктов
    initProducts: [],
    basket: [],
    httpInProgress: false,
    isOnlinePayment: false,
    isCourierPayment: null,
    screenSizeList: {
        mobileMin: 320,
        mobileMax: 480,
        iPadMin: 481,
        iPadMax: 768,
        laptopMin: 769,
        laptopMax: 1024,
        desktopMin: 1025,
        desktopMax: 1200,
        largeScreens: 1201,
    },
    pricesByPickupPoints: {},
}

if (process.env.NODE_ENV === 'development') {
    Vue.config.devtools = true
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins: [createPersistedState({
        paths: [
            'customer',
            'cityExact',
            'draftProducts',
            'currentVariants',
            'availableParameters',
            'lengthParameters',
            'cities',
            'questions',
            'filters',
            'products',
            'httpInProgress',
            'basket',
            'initProducts',
            'authenticatorData',
            'promoCode',
            'deliveryAddress',
            'bonusSystem',
            'pickupPoints',
            'selectPickupPoint',
            'screenSizeList',
            'deliveryType',
            'orderDetails',
        ],
    })],
})
